export const getIndexOfArraysInPathObject = (path: string) => {
  const regex = /[\d*?]/g;

  return path.match(regex);
};
